import { render, staticRenderFns } from "./editUserInfo.vue?vue&type=template&id=2262203c&scoped=true&"
import script from "./editUserInfo.vue?vue&type=script&lang=js&"
export * from "./editUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./editUserInfo.vue?vue&type=style&index=0&id=2262203c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262203c",
  null
  
)

export default component.exports